import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import ChecklistIcon from "@mui/icons-material/Checklist";

const ModalBenefitsOfMembership = ({ open, setOpen }) => {
  const { planName, description } = useSelector(
    (state) => state.membershipReducer
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center", fontSize: 24 }}>
            Membresía {planName}
          </Typography>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ textAlign: "center" }}>Beneficios</Typography>
          {description &&
            description.map((item, key) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                  // justifyContent: "center",
                  // alignItems: "center",
                  borderColor: "white",
                  borderWidth: 1,
                }}
                key={key}
              >
                <Box sx={{ display: "flex", gap: 1 }}>
                  <ChecklistIcon sx={{ color: "#e7ef7d" }} />
                  <Typography>{item ?? ""}</Typography>
                </Box>
              </Box>
            ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalBenefitsOfMembership;
